import React, { useEffect, useState } from "react";
import axios from "axios";
import cx from "classnames";
import MenuPage from "./menu.page";
import styles from "./order.module.scss";
import { useNavigate } from "@reach/router";
import NumberFormat from "react-number-format";
import ItemComponent from "./item.component";
import toast, { Toaster } from "react-hot-toast";

export default function OrderPage({ id, type }) {
  const [order, setOrder] = useState([]);
  const [orderSeq, setOrderSeq] = useState(0);
  const [menu, setMenu] = useState(false);
  const [complete, setComplete] = useState(false);
  const [total, setTotal] = useState(0);
  const [description, setDescription] = useState(undefined);
  const api = process.env.REACT_APP_API;
  const navigate = useNavigate();
  const [item, setItem] = useState(undefined);

  const close = () => {
    setMenu(false);
  };

  const closeMenu = () => {
    setMenu(false);
    setItem(undefined);
  };

  const guardar = (cat) => {
    console.log(order);
    if (type === "edit") {
      const promise = axios
        .post(`${api}order/edit`, {
          userBusiness: "5eb83bf737dfff8e9e8b2f38",
          business: "5eb83bf737dfff8e9e8b2f38",
          description: description,
          total: total,
          items: order.map((or) => {
            return {
              qty: or.qty,
              item: or.item,
              instructions: or.instructions,
              description: "",
              discount: parseInt(or.discount),
              total: or.total,
            };
          }),
          id: id,
          user: "5e9bfa0660adbac3ca166b46",
        })
        .then(({ data }) => {
          navigate(`/`);
        });

      toast.promise(promise, {
        loading: "Actualizando...",
        success: "Actualizado correcto!",
        error: "Uh oh, there was an error!",
      });
    } else {
      const promise = axios
        .post(`${api}order/add`, {
          business: "5eb83bf737dfff8e9e8b2f38",
          status: "5eb509db3390527550d48e18",
          description: description,
          total: total,
          source: "xolos menu",
          items: order.map((or) => {
            return {
              qty: or.qty,
              item: or.item,
              instructions: or.instructions,
              description: "",
              discount: parseInt(or.discount),
              total: or.total,
            };
          }),
          user: "5e9bfa0660adbac3ca166b46",
          found: true,
          contact: {
            id: "60fb76e1d07a080007af0060",
          },
        })
        .then(({ data }) => {
          navigate(`/`);
        });

      toast.promise(promise, {
        loading: "Guardando...",
        success: "Guardado correcto!",
        error: "Uh oh, there was an error!",
      });
    }
  };

  const completed = () => {
    let body = {
      id: id,
      status: "5eb509ef3390527550d48e19",
    };

    axios.post(`${api}order/edit/status`, body).then(({ data }) => {
      navigate(`/`);
      console.log(data);
    });
  };

  const remove = (obj, orderObj) => {
    let temp = [...order];
    let newTotal;
    let priceObj = 0;

    if (orderObj.item.extraPrice) {
      priceObj = orderObj.item.extraPrice * orderObj.qty;
    } else {
      priceObj = orderObj.item.price * orderObj.qty;
    }

    newTotal = total - priceObj;

    setTotal(newTotal);
    temp.splice(obj, 1);
    setOrder(temp);
  };

  useEffect(() => {
    if (type) {
      axios.get(`${api}order/getOne/${id}`).then(({ data }) => {
        setDescription(data.description);
        setOrderSeq(data.id);
        let newOrder = [];
        let totalEdit = 0;

        if (data.status.name !== "Completada") {
          setComplete(true);
        }

        data.items.map((item) => {
          let price = 0;
          let calc = 0;
          if (item.item.extraPrice) {
            calc = item.qty * item.item.extraPrice;
          } else {
            calc = item.qty * item.item.price;
          }

          if (item.discount) {
            calc = calc * (1 - (item.discount * 1) / 100);
          }
          totalEdit = totalEdit + calc;
          setTotal(totalEdit);
          newOrder.push({
            qty: item.qty,
            item: item.item,
            descripcion: item.description,
            instructions: item.instructions,
            discount: item.discount,
            total: calc,
          });
        });
        setOrder(newOrder);
      });
    }
  }, []);

  return (
    <div>
      <div className={styles.order}>
        <div className={styles.orderSeq}>#{orderSeq && orderSeq}</div>
        <div className={styles.orderDetalle}>
          <div
            className={cx(styles.orderItem, styles.orderHeader, styles.edit)}
          >
            <div className="qty">QTY</div>
            <div className="producto">Producto</div>
            <div className="total">Total</div>
            <div className={styles.action}></div>
          </div>
          {order.map((or, i) => {
            return (
              <div
                className={cx(styles.orderItem, styles.edit)}
                key={`${i}-order`}
              >
                <div className={styles.qty}>{or.qty}</div>
                <div className={styles.producto}>
                  <div className={styles.name}>{or.item.name}</div>
                  {or.item.selectedAttributes &&
                    or.item.selectedAttributes.map((attribute, i) => {
                      if (attribute.value) {
                        let tempText =
                          or.item.attributes.length > 0 &&
                          or.item.attributes.find(
                            (list) => list._id === attribute._id
                          );

                        return (
                          <span key={attribute._id}>
                            <b>{tempText ? tempText.title : ""}</b>:{" "}
                            {attribute.childValue.title}
                            {attribute.childValue.description && (
                              <span className={styles.attributeDescription}>
                                [{attribute.childValue.description}]
                              </span>
                            )}
                          </span>
                        );
                      } else if (attribute.multiple) {
                        let multipleText = "";
                        let text = "";
                        let tempText =
                          or.item.attributes.length > 0 &&
                          or.item.attributes.find(
                            (list) => list._id === attribute._id
                          );
                        attribute.multiple.map((m, i) => {
                          if (i == 0) {
                            multipleText = m.title;
                          } else {
                            multipleText = multipleText + " · " + m.title;
                          }
                        });
                        return (
                          <span key={attribute._id}>
                            <b>{tempText ? tempText.title : ""}</b>:{" "}
                            {multipleText}
                          </span>
                        );
                      }
                    })}

                  {or.instructions && (
                    <span key={or.item._id}>
                      <b>{"Instrucciones"}</b>: {or.instructions}
                    </span>
                  )}
                </div>
                <div className={styles.total}>
                  <NumberFormat
                    value={or.total}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={"$"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </div>
                <div className={styles.action}>
                  <div
                    className="button-icon remove"
                    onClick={remove.bind(null, i, or)}
                  >
                    <i className="fas fa-trash-alt"></i>
                  </div>
                </div>
              </div>
            );
          })}
          <div
            className={cx(styles.orderItem, styles.orderFooter, styles.edit)}
          >
            <div className="qty"></div>
            <div className={styles.producto}></div>
            <div className={styles.total}>
              <NumberFormat
                value={total}
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                fixedDecimalScale={true}
                decimalScale={2}
              />
            </div>
            <div className="actio"></div>
          </div>
          {/* {step && step.price && (
                      <div className="order-item order-footer">
                        <div className="qty"></div>
                        <div className="producto">Total + Envío</div>
                        <div className="discount"></div>
                        <div className="total">
                          <NumberFormat
                            value={total + step.price}
                            displayType={"text"}
                            thousandSeparator={true}
                            prefix={"$"}
                            fixedDecimalScale={true}
                            decimalScale={2}
                          />
                        </div>
                      </div>
                    )} */}
          <div className={styles.formGroup}>
            <label htmlFor="" style={{ width: "100%" }}>
              Indicaciones Especiales Generales
            </label>
            <input
              type="text"
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Indicaciones"
            />
          </div>
        </div>
      </div>
      <div className={styles.floating}>
        {!type && (
          <div className={styles.save} onClick={() => guardar()}>
            Guardar
          </div>
        )}
        {complete && (
          <div className={styles.update} onClick={() => guardar()}>
            Actualizar
          </div>
        )}
        {complete && (
          <div className={styles.complete} onClick={() => completed()}>
            Completar
          </div>
        )}

        <div className={styles.addProduct} onClick={() => setMenu(true)}>
          Agregar Producto
        </div>
        <div
          className={styles.close}
          onClick={() => {
            navigate(`/`);
          }}
        >
          Salir
        </div>
      </div>
      {menu && (
        <MenuPage
          close={close}
          setOrder={setOrder}
          order={order}
          setTotal={setTotal}
          total={total}
          setItem={setItem}
        />
      )}
      {item && (
        <ItemComponent
          product={item}
          setOrder={setOrder}
          order={order}
          setTotal={setTotal}
          total={total}
          close={closeMenu}
        />
      )}
    </div>
  );
}
